// ============================================
// CORE SERVICES - Main export
// ============================================

export * from './admin-admin-users.service';
export * from './admin-companies.service';
export * from './admin-modules.service';
export * from './admin-role-modules.service';
export * from './admin-roles.service';
export * from './auth.service';
export * from './cancellation-reasons.service';
export * from './car-types.service';
export * from './company-payment.service';
export * from './company-roles.service';
export * from './company-subscriptions.service';
export * from './company-user-blacklist.service';
export * from './company-user-cards.service';
export * from './company-user-places.service';
export * from './company-user-settings.service';
export * from './file-upload.service';
export * from './modules.service';
export * from './parameters.service';
export * from './rating-reasons.service';
export * from './setting-key.service';
export * from './subscription-plan.service';
export * from './user-settings.service';

// Re-export types
export * from './additionals.service';
export * from './car-settings.service';
export * from './cars.service';
export { CompanyService } from './company.service';
export type { FileUploadProgress, UploadedFile } from './file-upload.service';
export * from './payout-websocket.service';
export * from './payout.service';
export * from './company-nanny-tariffs.service';
export * from './users.service';
export * from './vats.service';
export * from './verification.service';

// ============================================
// [FAST] TRANSLATION SYSTEM - Centralized & Optimized
// ============================================

// Core translation services
export * from './language.service'; // Language coordination
export * from './simplified-translate-loader.service'; // Core modules loader
export * from './translation-cache.service'; // Centralized caching

// Route resolvers for automatic translation loading
export * from './route-translation.resolver'; // Route-based translation resolver

// ============================================
// DISPATCHER PANEL SERVICES
// ============================================

export * from './drivers.service';
export * from './google-maps.service';
export * from './notifications.service';
export * from './orders.service';
export * from './toast.service';
export * from './websocket-dispatcher.service';

